// extracted by mini-css-extract-plugin
export default {"modalSettingTable":"styles_modalSettingTable__tMKbO"};